<section class="
      col-xs-12 col-sm-12 col-md-12
      left-section
      Registration-nav-section
      section-height
    ">
  <div class="col-xs-12 col-sm-12 col-md-12 Registration-split recovery-split">
    <h3 class="reset-password-title">
      {{ "resetPassword.title" | cxTranslate }}
    </h3>


    <div class="error-message" *ngIf="invalidToken">
      {{ "resetPassword.invalidAccessToken" | cxTranslate }}</div>

    <div class="row">
      <div class="col-xs-12 col-sm-8 col-md-5 p0">
        <form [formGroup]="passwordForm">
          <div class="col-xs-12 col-sm-8 col-md-8 p0">
            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
              <label for="Password" class="Fields-label">{{ "resetPassword.newPassword" | cxTranslate }}
              </label>
              <input id="newPassword" name="newPassword" type="password" class="Fields-input"
                (ngModelChange)="validatePassword()" formControlName="newPassword" autocomplete="off" />
              <span role="alert" aria-live="assertive" *ngIf="
                    passwordIsNotValid &&
                    !passwordForm.get('newPassword').hasError('required')
                  " class="error-message">{{ "resetPassword.validPassword" | cxTranslate }}</span>
              <span role="alert" aria-live="assertive" *ngIf="
                    (passwordForm.get('newPassword').hasError('required') &&
                      passwordForm.get('newPassword').touched) ||
                    (passwordRequired && !passwordIsNotValid)
                  " class="error-message">{{ "forgotUserPassword.requiredField" | cxTranslate }}</span>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
              <label for="confirmPassword" class="Fields-label">{{
                "resetPassword.confirmNewPassword" | cxTranslate
                }}</label>
              <input name="checkPwd" type="password" class="Fields-input" formControlName="confirmPassword"
                autocomplete="off" (ngModelChange)="validateConfirmPassword()" />
              <span role="alert" aria-live="assertive" *ngIf="
                    (passwordForm.get('confirmPassword').hasError('required') &&
                      passwordForm.get('confirmPassword').touched) ||
                    confirmPasswordRequired
                  " class="error-message">{{ "forgotUserPassword.requiredField" | cxTranslate }}</span>
              <span role="alert" aria-live="assertive" *ngIf="
                    !passwordForm.get('confirmPassword').hasError('required') &&
                    passwordForm.get('newPassword').value !==
                      passwordForm.get('confirmPassword').value
                  " class="error-message">{{ "resetPassword.fieldsMismatchMsg" | cxTranslate }}</span>
            </div>

            <div class="Fields-btn-group">
              <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="
              passwordForm.invalid ||
                passwordIsNotValid ||
                passwordForm.get('newPassword').value !=
                  passwordForm.get('confirmPassword').value
              ">
                {{ "forgotUserPassword.submit" | cxTranslate }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="col-xs-12 col-sm-8 col-md-6 pwdrules_content">
        <span class="security-Notify">
          Your password must be at least 8 characters long and contain 3 of the following 4 elements:
        </span>
        <ul class="required-ul">
          <li>
            Lowercase letter
          </li>
          <li>
            Uppercase letter
          </li>
          <li>
            Number
          </li>
          <li>
            One of these special characters !&#64;$%^&*()
          </li>
        </ul>
        <span class="link_content" *ngIf="baseSiteId === 'vsh'">
          <span class="security-Notify">Remember that resetting your password here also updates it on our
            <a class="pass_tt" [ngbTooltip]="pass_tooltip" tooltipClass="info-tooltip" #tt="ngbTooltip"
              placement="bottom">
              other sites.
            </a>
            <ng-template #pass_tooltip>
              <div class="content">
                <span>These sites Include: </span>

                <li>VaccineShop Canada</li>
                <li>Vaccines.com</li>
                <li>SanofiShoppe</li>
                <li>CEACAM5.com</li>

              </div>
            </ng-template>
          </span>
        </span>
      </div>
    </div>
    <!-- <br /> -->
  </div>
</section>